import { Component, Inject, OnInit } from "@angular/core";
import { AccountMovementsViewModel, AccountingMovementEntryType } from "../../models/accounting-movement.model";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from '@angular/material/snack-bar';
import { AccountingMovementsListComponent } from "../accounting-movements-list.component";
import { SocialCapitalFormComponent } from "../../../user/partnersequity/social-capital/social-capital-form.component";
import { ReserveFormComponent } from "../../../user/partnersequity/reserve/reserve-form.component";
import { PrestamosFormComponent } from "../../../finanzas/prestamos/prestamos-form.component";
import { PrestamosModel } from "../../../finanzas/prestamos/prestamos.model";
import { ContactFormV2Component } from "../../../../modules_v2/contacts/components/contact-form-v2/contact-form-v2.component";
import { InvestmentFormComponent } from "../../../investment/intangible-material/investment-form.component";
import { InvestmentModel } from "../../../investment/investment.model";
import { ContactService } from "../../../contact/contact/contact.service";
import { TicketService } from "../../../invoice/tickets/ticket.service";
import { UserCompanyService } from "../../../user/usercompany/usercompany.service";
import { AccountingModelService } from "../../../user/accountingModel/accountingModel.service";
import { InvoiceTaxModel } from "../../../invoice/preinvoice/invoicetax.model";
import { UserCompanyModel } from "../../../user/usercompany/usercompany.model";
import { AccountingModel } from "../../../user/accountingModel/accountingModel.model";
import { EfectivoService } from "../../../../services/finanzas/efectivo/efectivo.service";
import { Efectivo } from "../../../../models/finanzas/efectivo/efectivo.model";
import { InvestmentPropertyFormComponent } from "../../../investment/property/investment-property-form.component";
import { InvestmentPropertyModel } from "../../../investment/property/investment-property.model";
import { InvestmentInCompaniesFormComponent } from "../../../investment/incompanies/investment-incompanies-form.component";
import { InvestmentInCompaniesModel } from "../../../investment/incompanies/investment-incompanies.model";
import { AccountingAccountsService } from "../../accounting-accounts/accounting-accounts.service";
import { AccountingAccountsModel } from "../../accounting-accounts/accounting-accounts.model";
import { InvestmentFinancialFormComponent } from "../../../investment/financial/investment-financial-form.component";
import { InvestmentFinancialModel } from "../../../investment/financial/investment-financial.model";
import { BankAccountFormComponent } from "../../../finanzas/bancos/bankaccount-form.component";
import { EfectivoDialogFormComponent } from "../../../finanzas/efectivo/efectivo-dialog-form.component";
import { PaymentCardFormComponent } from "../../../finanzas/paymentcard/paymentcard-form.component";
import { AccountingMovementsService } from "../accounting-movements.service";
import { PartnersFormComponent } from "../../../user/partnersequity/partners/partners-form.component";
import { FinanciacionPropiaFormComponent } from "../../../finanzas/financiacion-propia/financiacion-propia-form.component";
import { FinanciacionPropiaModel } from "../../../finanzas/financiacion-propia/financiacion-propia.model";
import { FinanciacionPrivadaFormComponent } from "../../../finanzas/financiacion-privada/financiacion-privada-form.component";
import { FinanciacionPrivadaModel } from "../../../finanzas/financiacion-privada/financiacion-privada.model";
import { BankAccountBicsModel } from "../../../finanzas/bancos/bankaccountbics.model";
import { BankAccountService } from "../../../finanzas/bancos/bankaccount.service";
import { SharedService } from "../../../../shared/services/shared.service";

@Component({
    selector: "convfact-accounting-movements-import",
    templateUrl: "./accounting-movements-import.component.html",
    styleUrls: ["../accounting-movements-list.component.css"],
    standalone: false
})
export class AccountingMovementsImportComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<AccountingMovementsListComponent>,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    private contactService: ContactService,
    private ticketService: TicketService,
    private userCompanyService: UserCompanyService,
    private accountingModelService: AccountingModelService,
    private efectivoService: EfectivoService,
    private accountingAccountsService: AccountingAccountsService,
    private accountingMovementsService: AccountingMovementsService,
    private bankAccountService: BankAccountService,
    private sharedService: SharedService,
    @Inject(MAT_DIALOG_DATA) public dataSource: any
  ) { }

  data: AccountMovementsViewModel[] = this.dataSource.data;
  flagType: boolean = this.dataSource.flagType;
  ready = false;
  flag = false;

  taxes: InvoiceTaxModel[] = [];
  userCompany: UserCompanyModel;
  useContanet: boolean = false;
  accounts: AccountingModel[] = [];
  accountingAccounts: AccountingAccountsModel[] = [];
  efectivoList: Efectivo[] = [];
  bankAccountBics: BankAccountBicsModel[] = [];

  dataSelected: AccountMovementsViewModel[] = [];

  all = false;

  pressCheckbox(cell: AccountMovementsViewModel) {
    if (this.dataSelected.includes(cell)) {
      this.dataSelected = this.dataSelected.filter(temp => temp !== cell);
    } else {
      this.dataSelected.push(cell);
    }
  }

  ngOnInit() {
    this.ticketService.accountsAndTaxesData().then(accountsAndTaxes => {
      this.taxes = accountsAndTaxes.taxes;

      this.userCompanyService.loadData().then(response => {
        this.userCompany = response;
        this.useContanet = this.userCompany.useContanet;

        this.accountingModelService.getListForContact().then(data => {
          this.accounts = data;

          this.efectivoService.list()
            .then(response => {
              this.efectivoList = response;

              this.bankAccountService.getBics().then(response => {
                this.bankAccountBics = response;

                this.accountingAccountsService.getListInvestmentsInCompaniesAccounts()
                  .then(data => {
                    this.accountingAccounts = data;
                    this.ready = true;
                  });
              })
            })
        })
      })
    })

  }

  startImportAll() {
    this.all = true;
    this.dataSelected = this.data;
    this.startImport();
    this.all = false;
  }

  startImport() {
    this.flag = false;
    this.dataSelected.forEach(movement => {

      //129 solo es asiento en contabilidad, Perdidas y ganancias
      if (movement.accountNumber.startsWith("129")) {
        let accountMovement = new AccountMovementsViewModel();
        accountMovement = movement;
        accountMovement.type = movement.description.toLowerCase();
        this.accountingMovementsService.accountMovementImportIteration(accountMovement).then(response => {
          const movModify = this.data.find(mov => mov == movement);
          movModify.imported = true;
        })
        this.flag = true;
      }

      //Actualización de cuenta si existe: No se hace ya que no hay dato que comparar.
      //Capital Social (100, 102)
      if (movement.accountNumber.startsWith("100") || movement.accountNumber.startsWith("102")) {
        this.capitalSocial(movement);
        this.flag = true;
      }

      //Actualización de cuenta si existe: No se aplica
      //Prima de emisión o asunción (110) (solo contabilidad)
      if (movement.accountNumber.startsWith("110")) {
        let accountMovement = new AccountMovementsViewModel();
        accountMovement = movement;
        accountMovement.type = movement.description.toLowerCase();
        this.accountingMovementsService.accountMovementImportIteration(accountMovement).then(response => {
          const movModify = this.data.find(mov => mov == movement);
          movModify.imported = true;
        })
        this.flag = true;
      }

      //Actualización de cuenta si existe: No se hace ya que no hay dato que comparar.
      //Reservas (112 Reserva legal, 113 Reserva Voluntaria, 114 RIC, )
      if (movement.accountNumber.startsWith("112") ||
        movement.accountNumber.startsWith("113") ||
        movement.accountNumber.startsWith("114")) {
        this.reservas(movement);
        this.flag = true;
      }

      //Actualización de cuenta si existe: Realizado: (backend)AccountingAccountsController.cs (Linea 49)
      //Socios 551
      if (movement.accountNumber.startsWith("551")) {
        this.socios(movement);
        this.flag = true;
      }

      //Actualización de cuenta si existe: No se aplica
      //Capital Socios 118
      if (movement.accountNumber.startsWith("118")) {
        let accountMovement = new AccountMovementsViewModel();
        accountMovement = movement;
        accountMovement.type = movement.description.toLowerCase();
        this.accountingMovementsService.accountMovementImportIteration(accountMovement).then(response => {
          const movModify = this.data.find(mov => mov == movement);
          movModify.imported = true;
        })
        this.flag = true;
      }

      //Actualización de cuenta si existe: No se aplica
      //Distrib. Resultado (120 Remanente, 121 Result. negativos ejercicios ant.)
      if (movement.accountNumber.startsWith("120") || movement.accountNumber.startsWith("121")) {
        movement.type = movement.description.toLowerCase();
        this.accountingMovementsService.accountMovementImportIteration(movement).then(response => {
          const movModify = this.data.find(mov => mov === movement);
          movModify.imported = true;
          this.flag = true;
        })
      }

      //Actualización de cuenta si existe: (backend)AccountingAccountsController.cs (Línea 97)
      //Préstamos (170 largo plazo, 5200 corto plazo)
      if (movement.accountNumber.startsWith("170") || movement.accountNumber.startsWith("5200")) {
        this.prestamo(movement);
        this.flag = true;
      }

      //Actualización de cuenta si existe: (backend)AccountingAccountsController.cs (linea 127)
      //Inversiones Intangibles (20), Inversiones Material (21), Inversiones En Curso (23)
      if (movement.accountNumber.startsWith("20") || movement.accountNumber.startsWith("21") ||
        movement.accountNumber.startsWith("23")) {
        this.inversionIntangibleMaterialEnCurso(movement);
        this.flag = true;
      }

      //Inversiones Inmobiliaria (22): (backend)AccountingAccountsController.cs (linea 142)
      if (movement.accountNumber.startsWith("22")) {
        this.inversionInmobiliaria(movement);
        this.flag = true;
      }

      //Inversiones En Empresas (24): (backend)AccountingAccountsController.cs (linea 159) 
      if (movement.accountNumber.startsWith("24")) {
        this.inversionEmpresa(movement);
        this.flag = true;
      }

      //Inversiones Financieras (25): (backend)AccountingAccountsController.cs (linea 176)
      if (movement.accountNumber.startsWith("25") || (movement.accountNumber.startsWith("54"))) {
        this.inversionFinanciera(movement);
        this.flag = true;
      }

      //Proveedores/acreedores (Cuenta subgrupo 40) (backend)AccountingAccountsController.cs (linea 80)
      if (movement.accountNumber.startsWith("40") || movement.accountNumber.startsWith("41")) {
        this.proveedoresAcreedoresClientes(movement, false, true);
        this.flag = true;
      }

      //Clientes (Cuenta subgrupo 43) (backend)AccountingAccountsController.cs (linea 80)
      if (movement.accountNumber.startsWith("43")) {
        this.proveedoresAcreedoresClientes(movement, true, false);
        this.flag = true;
      }

      //Bancos 572 - Bancos Moneda extranjera 573 (backend)AccountingAccountsController.cs (linea 192)
      if (movement.accountNumber.startsWith("572") || movement.accountNumber.startsWith("573")) {
        this.banks(movement);
        this.flag = true;
      }

      //Caja 570 - Caja (backend)AccountingAccountsController.cs (linea 210)
      if (movement.accountNumber.startsWith("570")) {
        this.efectivo(movement);
        this.flag = true;
      }

      //Tarjetas 5201 - Tarjetas debito/credito (backend)AccountingAccountsController.cs (linea 228)
      if (movement.accountNumber.startsWith("5201")) {
        this.paymentCards(movement);
        this.flag = true;
      }

      //Financiación Propia (Corto plazo: 5133, 5134, 5135) (backend)AccountingAccountsController.cs (linea 245)
      //(Largo plazo: 1633, 1634, 1635)
      if (movement.accountNumber.startsWith("5133") ||
        movement.accountNumber.startsWith("5134") ||
        movement.accountNumber.startsWith("5135") ||
        movement.accountNumber.startsWith("1633") ||
        movement.accountNumber.startsWith("1634") ||
        movement.accountNumber.startsWith("1635")) {
        this.propia(movement);
        this.flag = true;
      }

      //Financiación Privada (521, 171) (backend)AccountingAccountsController.cs ()
      if (movement.accountNumber.startsWith("521") ||
        movement.accountNumber.startsWith("171")) {
        this.privada(movement);
        this.flag = true;
      }

      //Si la cuenta de contabilidad no está contemplada en los condcionales anteriores...
      if (this.flag === false) {
        let accountMovement = new AccountMovementsViewModel();
        accountMovement = movement;
        accountMovement.type = movement.description.toLowerCase();

        this.sharedService.checkIfAccountNumberExists(movement.accountNumber, accountMovement.type).then(response => {
          movement.accountNumber = response;
          this.accountingMovementsService.accountMovementImportIteration(accountMovement).then(result => {
            const movModify = this.data.find(mov => mov == movement);
            movModify.imported = true;
            movModify.closed = false;
          });
        });
      }
    });
  }


  socios(movement: AccountMovementsViewModel) {
    this.dialog.open(PartnersFormComponent, {
      width: '520px',
      maxWidth: '95vw',
      data: {
        movement: movement,
        type: movement.description.toLowerCase(),
        flagImport: true,
        uid: "0"
        ,
      }
    }).afterClosed().subscribe(result => {
      const value: boolean = result;
      const movModify = this.data.find(mov => mov == movement);
      if (value === true) {
        movModify.imported = true;
        movModify.closed = false;
      } else {
        movModify.imported = false;
        movModify.closed = true;
      }
    });
  }

  paymentCards(movement: AccountMovementsViewModel) {
    this.dialog.open(PaymentCardFormComponent, {
      width: '580px',
      maxWidth: '96vw',
      maxHeight: '90vh',
      autoFocus: false,
      data: {
        movement: movement,
        type: movement.description.toLowerCase(),
        flagImport: true,
        uid: "0"
        ,
      }
    }).afterClosed().subscribe(result => {
      const value: boolean = result;
      const movModify = this.data.find(mov => mov == movement);
      if (value === true) {
        movModify.imported = true;
        movModify.closed = false;
      } else {
        movModify.imported = false;
        movModify.closed = true;
      }
    });
  }

  banks(movement: AccountMovementsViewModel) {
    const dialogRef = this.dialog.open(BankAccountFormComponent, {
      width: '520px',
      maxWidth: '95vw',
      data: {
        movement: movement,
        type: movement.description.toLowerCase(),
        flagImport: true,
        uid: "0"
      },
    })

    const instance = dialogRef.componentInstance;
    instance.bankAccountBics = this.bankAccountBics;
    dialogRef.afterClosed().subscribe(result => {
      const value: boolean = result;
      const movModify = this.data.find(mov => mov == movement);
      if (value === true) {
        movModify.imported = true;
        movModify.closed = false;
      } else {
        movModify.imported = false;
        movModify.closed = true;
      }
    });
  }

  efectivo(movement: AccountMovementsViewModel) {
    this.dialog.open(EfectivoDialogFormComponent, {
      width: '520px',
      maxWidth: '95vw',
      data: {
        movement: movement,
        type: movement.description.toLowerCase(),
        flagImport: true,
        isEditMode: false,
        uid: "0"
      },
    }).afterClosed().subscribe(result => {
      const value: boolean = result;
      const movModify = this.data.find(mov => mov == movement);
      if (value === true) {
        movModify.imported = true;
        movModify.closed = false;
      } else {
        movModify.imported = false;
        movModify.closed = true;
      }
    });
  }

  capitalSocial(movement: AccountMovementsViewModel) {
    this.dialog.open(SocialCapitalFormComponent, {
      width: '520px',
      maxWidth: '95vw',
      data: {
        movement: movement,
        type: movement.description.toLowerCase(),
        flagImport: true
      },
    }).afterClosed().subscribe(result => {
      const value: boolean = result;
      const movModify = this.data.find(mov => mov == movement);
      if (value === true) {
        movModify.imported = true;
        movModify.closed = false;
      } else {
        movModify.imported = false;
        movModify.closed = true;
      }
    });
  }

  reservas(movement: AccountMovementsViewModel) {
    this.dialog.open(ReserveFormComponent, {
      width: '520px',
      maxWidth: '95vw',
      data: {
        movement: movement,
        flagImport: true,
        type: movement.description.toLowerCase(),
      },
    }).afterClosed().subscribe(result => {
      const value: boolean = result;
      const movModify = this.data.find(mov => mov == movement);
      if (value === true) {
        movModify.imported = true;
        movModify.closed = false;
      } else {
        movModify.imported = false;
        movModify.closed = true;
      }
    });
  }

  privada(movement: AccountMovementsViewModel) {
    const dialogRef = this.dialog.open(FinanciacionPrivadaFormComponent, {
      width: '700px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      data: {
        movement: movement,
        type: movement.description.toLowerCase(),
        flagImport: true
      }
    });

    const instance = dialogRef.componentInstance;
    instance.financiacionPrivada = new FinanciacionPrivadaModel();
    dialogRef.afterClosed().subscribe(result => {
      const value: boolean = result;
      const movModify = this.data.find(mov => mov == movement);
      if (value === true) {
        movModify.imported = true;
        movModify.closed = false;
      } else {
        movModify.imported = false;
        movModify.closed = true;
      }
    });
  }

  propia(movement: AccountMovementsViewModel) {
    const dialogRef = this.dialog.open(FinanciacionPropiaFormComponent, {
      width: '700px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      data: {
        movement: movement,
        type: movement.description.toLowerCase(),
        flagImport: true
      }
    });

    const instance = dialogRef.componentInstance;
    instance.financiacionPropia = new FinanciacionPropiaModel();
    dialogRef.afterClosed().subscribe(result => {
      const value: boolean = result;
      const movModify = this.data.find(mov => mov == movement);
      if (value === true) {
        movModify.imported = true;
        movModify.closed = false;
      } else {
        movModify.imported = false;
        movModify.closed = true;
      }
    });
  }

  prestamo(movement: AccountMovementsViewModel) {
    movement.reference = movement.reference.substring(0, 30);
    const dialogRef = this.dialog.open(PrestamosFormComponent, {
      width: '700px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      data: {
        movement: movement,
        type: movement.description.toLowerCase(),
        flagImport: true
      }
    });

    const instance = dialogRef.componentInstance;
    instance.prestamos = new PrestamosModel();
    dialogRef.afterClosed().subscribe(result => {
      const value: boolean = result;
      const movModify = this.data.find(mov => mov == movement);
      if (value === true) {
        movModify.imported = true;
        movModify.closed = false;
      } else {
        movModify.imported = false;
        movModify.closed = true;
      }
    });
  }

  async proveedoresAcreedoresClientes(movement: AccountMovementsViewModel, client: boolean, provider: boolean, debtor: boolean = false) {
    const type = movement.description.toLowerCase();
    let accountNumber = movement.accountNumber;
    if (client || provider) {
      try {
        const calculated = await this.sharedService.checkIfAccountNumberExists(movement.accountNumber, type);
        if (calculated) accountNumber = calculated;
      } catch {
        accountNumber = movement.accountNumber;
      }
    }

    const scratch = {
      companyName: movement.reference,
      isClient: client,
      isProvider: provider,
      isDebtor: debtor,
      accountNumberClient: client ? accountNumber : null,
      accountNumberProvider: provider ? accountNumber : null,
      accountNumberDebtor: debtor ? accountNumber : null,
      manualMovement: { ...movement, type, accountNumber },
    };

    ContactFormV2Component.open(this.dialog, { scratch, importMode: true }).subscribe(result => {
      const movModify = this.data.find(mov => mov == movement);
      if (!movModify) return;
      if (result) {
        movModify.imported = true;
        movModify.closed = false;
      } else {
        movModify.imported = false;
        movModify.closed = true;
      }
    });
  }

  inversionIntangibleMaterialEnCurso(movement: AccountMovementsViewModel) {
    const dialogRef = this.dialog.open(InvestmentFormComponent, {
      width: '700px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      data: {
        movement: movement,
        type: movement.description.toLowerCase(),
        flagImport: true
      },
    });
    const instance = dialogRef.componentInstance;
    instance.investment = new InvestmentModel();
    this.contactService.getListProviders().then(contacts => instance.providers = contacts);

    dialogRef.afterClosed().subscribe(result => {
      const value: boolean = result;
      const movModify = this.data.find(mov => mov == movement);
      if (value === true) {
        movModify.imported = true;
        movModify.closed = false;
      } else {
        movModify.imported = false;
        movModify.closed = true;
      }
    });
  }

  inversionInmobiliaria(movement: AccountMovementsViewModel) {
    const dialogRef = this.dialog.open(InvestmentPropertyFormComponent, {
      width: '700px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      data: {
        movement: movement,
        type: movement.description.toLowerCase(),
        flagImport: true
      },
    });
    const instance = dialogRef.componentInstance;
    instance.investmentProperty = new InvestmentPropertyModel();
    this.contactService.getListProviders().then(contacts => instance.contactList = contacts);
    dialogRef.afterClosed().subscribe(result => {
      const value: boolean = result;
      const movModify = this.data.find(mov => mov == movement);
      if (value === true) {
        movModify.imported = true;
        movModify.closed = false;
      } else {
        movModify.imported = false;
        movModify.closed = true;
      }
    });
  }

  inversionEmpresa(movement: AccountMovementsViewModel) {
    const dialogRef = this.dialog.open(InvestmentInCompaniesFormComponent, {
      width: '700px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      data: {
        movement: movement,
        type: movement.description.toLowerCase(),
        flagImport: true
      },
    });
    const instance = dialogRef.componentInstance;
    instance.investmentInCompanies = new InvestmentInCompaniesModel();
    instance.accounts = this.accountingAccounts;
    dialogRef.afterClosed().subscribe(result => {
      const value: boolean = result;
      const movModify = this.data.find(mov => mov == movement);
      if (value === true) {
        movModify.imported = true;
        movModify.closed = false;
      } else {
        movModify.imported = false;
        movModify.closed = true;
      }
    });
  }

  inversionFinanciera(movement: AccountMovementsViewModel) {
    const dialogRef = this.dialog.open(InvestmentFinancialFormComponent, {
      width: '700px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      data: {
        movement: movement,
        type: movement.description.toLowerCase(),
        flagImport: true
      },
    });
    const instance = dialogRef.componentInstance;
    instance.investmentFinancial = new InvestmentFinancialModel();
    instance.accounts = this.accountingAccounts;
    dialogRef.afterClosed().subscribe(result => {
      const value: boolean = result;
      const movModify = this.data.find(mov => mov == movement);
      if (value === true) {
        movModify.imported = true;
        movModify.closed = false;
      } else {
        movModify.imported = false;
        movModify.closed = true;
      }
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }

  public trackByIndex(i: number) { return i; }

}
